import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

import { CopyToClipboard } from '@10xLabs/react-web/components/CopyToClipboard'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td, IdWrapper, TdId } from 'components/v2/Table'
import { IsActive } from 'components/Chip'
import { BusinessSiteActions } from 'features/BusinessSites/views/Index/Actions'
import { IBusinessSitesListProps } from 'features/BusinessSites/views/Index/List/types'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { useLogin } from 'features/Login/hooks'
import { canWrite } from 'features/Users/utils'

export const BusinessSitesList = ({ businessSites = [] }: IBusinessSitesListProps): ReactElement => {
  const login = useLogin()
  const canSeeActions = canWrite(FEATURES.BUSINESS_SITE, login.accessToken.policies)

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            {canSeeActions && <Th />}
            <Th>
              <FormattedMessage id="businessStes.list.id" defaultMessage="Site Id" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.status" defaultMessage="Status" />
            </Th>
            <Th>
              <FormattedMessage id="businessSites.list.siteName" defaultMessage="Site Name" />
            </Th>
            <Th>
              <FormattedMessage id="businessSites.list.clientName" defaultMessage="Client Name" />
            </Th>
            <Th>
              <FormattedMessage id="businessSites.list.city" defaultMessage="City" />
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {businessSites.map((businessSite): ReactElement => {
            return (
              <Tr key={businessSite.id}>
                {canSeeActions && (
                  <Td>
                    <BusinessSiteActions businessSite={businessSite} />
                  </Td>
                )}
                <TdId>
                  <IdWrapper>
                    {businessSite.id.substring(0, 8)}
                    <CopyToClipboard str={businessSite.id} />
                  </IdWrapper>
                </TdId>
                <Td>
                  <IsActive isActive={businessSite.isActive} />
                </Td>
                <Td>{businessSite.name}</Td>
                <Td>{businessSite.client?.name}</Td>
                <Td>{businessSite.city?.id ? businessSite.city.name : '-'}</Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
